<template>
	<div :class="tooltipClasses">
		<div :class="['map-tooltip-header']">
			{{ $t('home-map.tooltip.headers.qualityRectangle') }}
		</div>
		<div class="map-tooltip-content">
			<div class="nobr">
				{{ $t('home-map.tooltip.vrsPst') }}:
				{{ vrsPstDisplay }}
			</div>
			<div class="nobr">
				{{ $t('home-map.tooltip.qEff') }}:
				{{ qEffDisplay }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { computed, toRef } from 'vue';
import type { PropType } from 'vue';
import { useLocaleData } from '@/locales/useLocaleData';

import type { QualityRectangleFeatureData } from '@/components/map/types/mapFeatureTypes';

export default {
	props: {
		hoveredFeatureData: {
			type: Object as PropType<QualityRectangleFeatureData>,
			required: true,
		},
	},
	setup(props) {
		const { localeData } = useLocaleData();
		const tooltipClasses = computed(() => [
			'map-tooltip-style',
			'map-tooltip-position-' + localeData.value.direction,
			'no-pointer-events',
		]);
		const hoveredFeatureDataRef = toRef(props, 'hoveredFeatureData');
		const vrsPstDisplay = computed(() => {
			const raw = hoveredFeatureDataRef.value?.vrs_pst;
			const n = Number(raw);
			if (raw == null || Number.isNaN(n)) {
				return '—';
			}
			return n.toFixed(3);
		});
		const qEffDisplay = computed(() => {
			const raw = hoveredFeatureDataRef.value?.q_eff;
			const n = Number(raw);
			if (raw == null || Number.isNaN(n)) {
				return '—';
			}
			return n.toFixed(1);
		});
		return {
			tooltipClasses,
			vrsPstDisplay,
			qEffDisplay,
		};
	},
};
</script>

<style scoped>
@import '@/assets/map-tooltip.css';
</style>
